<template>
    <div>
        <template v-if="expense_payments === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Expense Payments</h1>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" name="" />
                </div>
            </div>
            <table id="expensePaymentReconciledTable" class="table" width="100%">
                <thead>
                    <tr>
						<th>Expense ID</th>
						<th>Applied By</th>
						<th>Expense Purpose</th>
						<th>Requested Amount</th>
						<th>Approved Amount</th>
						<th>Reconciled Amount</th>
                        <th>Unreconciled Amount</th>
						<th class="text-center" >View Receipts</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="expense_payments === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="expense_payments === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                expense_payments: null
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('expense_payments').then(result => {
                this.expense_payments = result.expense_payments;
            }).then(result => {
                if(this.expense_payments == true){
					this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
			callDataTable(){
                var that = this;
                var expensePaymentReconciledTable = $('#expensePaymentReconciledTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "/api/eMoney/countExpensePayments",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records"
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id'},
						{data: 'applied_by'},
						{data: 'expense_name'},
                        {
                            name: "expense_requested_amount",
                            mData: "expense_requested_amount",
                            render: $.fn.dataTable.render.number(",")
                        },
                        {
                            name: "expense_approved_amount",
                            mData: "expense_approved_amount",
                            render: $.fn.dataTable.render.number(",")
                        },
                        {
                            name: "expense_reconciled_amount",
                            mData: "expense_reconciled_amount",
                            render: $.fn.dataTable.render.number(",")
                        },

                        { data: "id",
                            render: function(data, type, full) {
                                var expense_unreconciled_amount = full["expense_approved_amount"] - full["expense_reconciled_amount"];
                                
                                return (
                                    expense_unreconciled_amount
                                );
                            }  
                        },
                        {data: 'id', sorting: false, 
							render: function(data,type,full){
								var $url = '/viewAllReceipts/'+full['id'];
								return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View All Receipts" class="action edit"><i class="fas fa-eye"></i></a>';
							}
							
						}
                    ],
                    drawCallback: function(settings){
                        $(".action").tooltip();
                    },
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 6 ]
                    }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        expensePaymentReconciledTable.search(this.value).draw();
                    }
                });
            }
        }
    }
</script>
